import ReactGA from 'react-ga';

import { CHANGE_STEP, CART_ADD, CART_REMOVE, CART_PAY, CART_PAID, COUPON_ADD } from "../actions/actionTypes";

const stepsMiddleware = store => next => action => {

    next(action);
    
    let gaState = store.getState();
    // if product exists - return name
    let productName = gaState.cart.byHash['1'] ? gaState.cart.byHash['1'].content.name : null;
    let stage = gaState.common.stepIndex + 1;
    let totalPrice = gaState.cart.totals.subtotal;
    let stageDesc = {
        1: "Signup / Login",
        2: "Billing Address",
        3: "Payment"
    }

    // send ga-analytics events data as actions are dispatched
    switch(action.type) {
        // case LOGIN_USERNAME_PASSWORD: 
        //     ReactGA.event({
        //         category: 'User login',
        //         action: ``
        //     });
        //     break;
        // case SIGNUP:
        //     ReactGA.event({
        //         category: 'User signed up',
        //         action: ``
        //     });
        //     break;
        case CHANGE_STEP: 
            ReactGA.event({
                category: `Stage ${stage} - ${stageDesc[stage]}`,
                action: `Moved to stage ${stage}`
            });
            break;
        case CART_ADD:
            ReactGA.event({
                category: 'Product Added',
                action: `Added ${productName}`
            });
            break;
        case CART_REMOVE:
            ReactGA.event({
                category: 'Product Removed',
                action: 'Removed Product'
            });
            break;
        case CART_PAY:
            ReactGA.event({
                category: 'Pay',
                action: `User clicked pay for ${productName}`
            });
            break;
        case CART_PAID:
            ReactGA.event({
                category: 'Paid',
                action: `User paid for ${productName}, total ${totalPrice}`
            });
            break;
        case COUPON_ADD:
            ReactGA.event({
                category: 'Added Coupon',
                action: `User added coupon`
            });
            break;
        default:
            return;
    }
};

export default stepsMiddleware